import { Injectable } from '@angular/core';
import { waitForMillis } from '@shared/delay.utils';
import { random } from '@shared/misc.utils';
import CONFETTI from 'canvas-confetti';

@Injectable({
  providedIn: 'root',
})
export class LpParticlesService {
  public async playPaperParticles(element: HTMLElement): Promise<void> {
    const bounds = element.getBoundingClientRect();
    CONFETTI({
      startVelocity: 5,
      spread: 180,
      ticks: 60,
      zIndex: 0,
      colors: ['ffffff'],
      angle: 180,
      particleCount: 10,
      origin: {
        x: bounds.left / window.innerWidth,
        y: (bounds.top + bounds.height / 2) / window.innerHeight,
      },
    });
    CONFETTI({
      startVelocity: 5,
      spread: 180,
      ticks: 60,
      zIndex: 0,
      colors: ['ffffff'],
      angle: 0,
      particleCount: 10,
      origin: {
        x: (bounds.left + bounds.width) / window.innerWidth,
        y: (bounds.top + bounds.height / 2) / window.innerHeight,
      },
    });
    await waitForMillis(1000);
  }

  public async playFireworks(durationInMs: number, colors: string[]): Promise<void> {
    const animationEnd = Date.now() + durationInMs;
    while (true) {
      const timeLeft = animationEnd - Date.now();
      const particleCount = 140 * (timeLeft / durationInMs);

      const base = {
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 0,
        colors,
      };
      CONFETTI({
        ...base,
        particleCount,
        origin: { x: random(0.1, 0.3), y: random(0, 1) - 0.2 },
      });
      CONFETTI({
        ...base,
        particleCount,
        origin: { x: random(0.7, 0.9), y: random(0, 1) - 0.2 },
      });

      await waitForMillis(250);
    }
  }
}
